<template>
  <div class="user-avatar">
    <component
      :is="hasTooltip ? 'm-tooltip' : 'div'"
      placement="top"
    >
      <m-avatar
        :color="avatarColor"
        :size="size"
        :src="profileImage"
        :class="['user-avatar']"
        :bordered="bordered"
        :text="avatarText"
        black-and-white
        shape="circle"
      />
      <template
        v-if="hasTooltip"
        #title
      >
        {{ avatarText }}
      </template>
    </component>
  </div>
</template>

<script>
import colors from 'shared/colors';

export default {
  name: 'UserAvatar',
  props: {
    user: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      required: true,
    },
    color: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 24,
    },
    left: {
      type: Boolean,
      default: false,
    },
    hasTooltip: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: '',
    },
  },
  computed: {
    avatarText() {
      if (this.user === null) {
        return this.$t('user.deleted.name');
      }
      const name = `${this.user.firstName} ${this.user.lastName}`.trim();
      if (name === '') {
        return this.user.email;
      }
      return name;
    },
    profileImage() {
      if (this.user === null || this.user.profileImage === undefined || this.user.profileImage === null) {
        return '';
      }

      return this.user.profileImage.getURL;
    },
    colors() {
      return [
        colors.blue.lighten1,
        colors.blue.base,
        colors.blue.darken1,
        colors.green.lighten1,
        colors.green.base,
        colors.green.darken1,
        colors.yellow.lighten1,
        colors.yellow.base,
        colors.yellow.darken1,
        colors.orange.lighten1,
        colors.orange.base,
        colors.orange.darken1,
        colors.red.lighten1,
        colors.red.base,
        colors.red.darken1,
      ];
    },
    avatarColor() {
      if (this.color !== '' || this.user === null) {
        return this.color;
      }

      const i = this.user.uid % (this.colors.length - 1);
      return this.colors[i];
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .user-avatar {
    display: inline;
  }
</style>
